import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://www.mareaa.online/cart/53202441404781:1';
export function OfferSection() {
  return <section className="w-full bg-white py-16 px-4 md:px-8" data-id="element-139">
      <div className="max-w-xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-primary to-primary-mid p-8 md:p-10 rounded-3xl shadow-2xl text-white" data-id="element-141">
          <p className="text-center text-white/60 text-sm uppercase tracking-wider mb-3" data-id="element-142">
            💰 La Oferta
          </p>

          <h2 className="text-2xl md:text-3xl font-serif text-white text-center mb-6" data-id="element-143">
            Empezá hoy a desinflamarte… o seguí sintiéndote igual
          </h2>

          <div className="text-center mb-6" data-id="element-144">
            <p className="text-white/60 text-sm mb-1" data-id="element-145">
              El valor total de todo este material es de
            </p>
            <p className="text-2xl font-bold line-through opacity-50" data-id="element-146">
              $30.000 ARS
            </p>
          </div>

          <div className="text-center mb-6" data-id="element-147">
            <p className="text-white/80 text-sm mb-2" data-id="element-148">
              Pero hoy podés acceder con descuento especial:
            </p>
            <div className="bg-white/15 backdrop-blur-sm p-6 rounded-2xl inline-block" data-id="element-149">
              <div className="flex items-center gap-2 justify-center mb-1" data-id="element-150">
                <span className="text-white/50 text-lg line-through" data-id="element-151">
                  $30.000
                </span>
                <span className="text-white/50" data-id="element-152">→</span>
              </div>
              <div className="text-5xl md:text-6xl font-bold text-yellow-300 font-serif" data-id="element-153">
                $6.999
              </div>
              <p className="text-white/70 mt-1 text-sm" data-id="element-154">ARS</p>
            </div>
            <p className="text-white/50 text-xs mt-3" data-id="element-155">
              Menos de lo que gastás en un almuerzo
            </p>
          </div>

          <div className="space-y-2 mb-6 max-w-xs mx-auto" data-id="element-156">
            <p className="flex items-center gap-2 text-white/90 text-sm" data-id="element-157">
              <span className="text-accent-light" data-id="element-158">✓</span> Acceso inmediato
            </p>
            <p className="flex items-center gap-2 text-white/90 text-sm" data-id="element-159">
              <span className="text-accent-light" data-id="element-160">✓</span> Descarga digital — es
              tuyo para siempre
            </p>
            <p className="flex items-center gap-2 text-white/90 text-sm" data-id="element-161">
              <span className="text-accent-light" data-id="element-162">✓</span> Guía completa + los 3
              bonos incluidos
            </p>
            <p className="flex items-center gap-2 text-white/90 text-sm" data-id="element-163">
              <span className="text-accent-light" data-id="element-164">✓</span> Sin dietas extremas
              ni complicaciones
            </p>
          </div>

          <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="flex items-center justify-center gap-3 w-full bg-accent hover:bg-accent/90 text-white font-bold text-base md:text-lg py-5 rounded-full shadow-xl shadow-accent/30 transition-all duration-300" data-id="element-165">
            SÍ, QUIERO DESINFLAMAR MI ABDOMEN DESDE HOY
            <ArrowRightIcon className="w-5 h-5" data-id="element-166" />
          </motion.a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-5 bg-highlight/10 border-2 border-highlight/30 p-4 rounded-xl text-center" data-id="element-167">
          <p className="text-sm font-semibold text-text-dark" data-id="element-168">
            ⚠️ Este precio puede cambiar en cualquier momento
          </p>
        </motion.div>
      </div>
    </section>;
}